import { render } from "./LbrxQueuePopup.vue?vue&type=template&id=7bf3b538&scoped=true"
import script from "./LbrxQueuePopup.vue?vue&type=script&lang=js"
export * from "./LbrxQueuePopup.vue?vue&type=script&lang=js"

import "./LbrxQueuePopup.vue?vue&type=style&index=0&id=7bf3b538&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf3b538"]])

export default __exports__